import { Link } from "react-router-dom";
import { ArrowLeft, Download, FileText } from "lucide-react";

export function CorporatePolicy() {
    const pdfUrl = "/documenti/politiche-aziendali.pdf";

    return (
        <div className="container py-12 md:py-16">
            <Link to="/" className="inline-flex items-center text-text-body hover:text-brand-primary mb-8 transition-colors">
                <ArrowLeft className="h-4 w-4 mr-2" /> Torna alla Home
            </Link>
            
            <div className="max-w-5xl mx-auto">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
                    <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-title">Politica Aziendale</h1>
                    
                    <a 
                        href={pdfUrl} 
                        download 
                        className="inline-flex items-center px-6 py-3 bg-brand-primary text-white font-medium rounded-lg hover:bg-brand-secondary transition-colors shadow-md"
                    >
                        <Download className="h-5 w-5 mr-2" />
                        Scarica PDF
                    </a>
                </div>

                <div className="prose prose-lg text-text-body max-w-none mb-10">
                    <h2 className="text-2xl font-bold text-text-title mb-4">Introduzione alle Politiche Aziendali</h2>
                    <p className="mb-4">
                        Le politiche aziendali rappresentano l’insieme dei principi, degli obiettivi e degli impegni che guidano un’organizzazione nel perseguimento della propria missione. Sono strumenti fondamentali per definire le linee guida operative e strategiche, assicurare la qualità dei servizi offerti, garantire il rispetto delle normative e promuovere una cultura orientata al miglioramento continuo e alla sostenibilità.
                    </p>
                    <p>
                        In questa sezione è possibile consultare la Politica Aziendale di PUGLIA LIFE S.r.l., che illustra gli impegni dell’azienda verso i propri clienti, l’ambiente e la collettività, in linea con gli standard internazionali di qualità e gestione ambientale.
                    </p>
                </div>
                
                <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                    <div className="p-6 md:p-8 bg-gray-50 border-b border-gray-100">
                        <div className="flex items-center space-x-3 text-text-title font-semibold text-lg">
                            <FileText className="h-6 w-6 text-brand-primary" />
                            <span>Visualizzatore Documento</span>
                        </div>
                        <p className="text-text-body text-sm mt-2">
                            Visualizza il documento direttamente qui sotto oppure usa il pulsante "Scarica PDF" per salvarlo sul tuo dispositivo.
                        </p>
                    </div>
                    
                    <div className="w-full h-[800px] bg-gray-100">
                        <iframe 
                            src={`${pdfUrl}#toolbar=0`}
                            className="w-full h-full border-0"
                            title="Politica Aziendale PDF"
                        />
                    </div>
                </div>
                
                <div className="mt-8 p-4 bg-blue-50 text-blue-800 rounded-lg text-sm">
                    <p>
                        <strong>Nota:</strong> Se non riesci a visualizzare il PDF nel browser, puoi scaricarlo cliccando sul pulsante in alto a destra.
                    </p>
                </div>
            </div>
        </div>
    );
}
